import React from "react";
import {BooleanRadioButton, BooleanRadioButtonGroup} from "@octopusdeploy/design-system-components";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {HostedInstanceResource} from "client/resources/hostedInstanceResource";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import Select from "components/form/Select/Select";
import { KubernetesClusterResource } from "client/resources/KubernetesClusterResource";
import { MoveComputeRequest } from "~/client/resources/moveComputeRequest";
import { instancesRouteLinks } from "areas/instances/instancesRouteLinks";
import { InternalRedirect } from "components/Navigation/InternalRedirect";

interface Props {
    instance: HostedInstanceResource;
}

interface State extends DataBaseComponentState {
    kubernetesClusters: KubernetesClusterResource[];
    request: Partial<MoveComputeRequest>;
    redirectTo?: string;
}

export class MoveComputeDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            kubernetesClusters: [],
            request: {
                DestinationKubernetesClusterName: this.props.instance.KubernetesClusterName,
                MoveDuringOutageWindow: true,
            }
        };
    }

    async componentDidMount() {
        await this.doBusyTask(async () => {
            const reef = await repository.Reefs.get(this.props.instance.ReefId);
            this.setState({ kubernetesClusters: reef.KubernetesClusters.filter(c => c.Name !== this.props.instance.KubernetesClusterName) });
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <InternalRedirect to={this.state.redirectTo}/>;
        }

        const instance = this.props.instance;
        const request = this.state.request;
        return <SaveDialogLayout title={"Move Between Kubernetes Clusters"}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 saveButtonDisabled={instance.KubernetesClusterName === request.DestinationKubernetesClusterName}
                                 onSaveClick={() => this.moveCompute()}>
            <Select value={request.DestinationKubernetesClusterName}
                    onChange={clusterName => this.updateRequest({DestinationKubernetesClusterName: clusterName})}
                    items={this.state.kubernetesClusters.map(c => ({text: c.Name, value: c.Name}))}
                    fieldName="Destination Kubernetes Cluster"
                    hintText="The destination Kubernetes cluster to move to"
            />
            <BooleanRadioButtonGroup value={request.MoveDuringOutageWindow} onChange={moveDuringOutageWindow => this.updateRequest({MoveDuringOutageWindow: moveDuringOutageWindow})}>
                <BooleanRadioButton value={true} label="Move During Outage Window" />
                <BooleanRadioButton value={false} label="Move Immediately" />
            </BooleanRadioButtonGroup>
        </SaveDialogLayout>;
    }

    private updateRequest(update: Partial<MoveComputeRequest>) {
        return this.setState(prevState => ({request: {...prevState.request, ...update}}));
    }

    private moveCompute() {
        return this.doBusyTask(async () => {

            const instanceId = this.props.instance.Id;
            await repository.HostedInstances.moveCompute(instanceId, this.state.request as MoveComputeRequest);
            this.setState({redirectTo: instancesRouteLinks.instance(instanceId).tasks});
        });
    }
}
